<template lang="pug">
div.payment-method-modern(:class="[$colorMode.value]")
  .payment-grid
    .payment-option(
      v-for='method in paymentMethods' 
      :key="method.name"
      @click="selectPaymentMethod(method)"
      :class="{ 'is-selected': selectedPaymentMethod?.name === method?.name }"
    )
      .option-content
        .option-header
          .radio-indicator
            .radio-outer
            .radio-inner
          .method-name {{ $t(method.name) }}

          //- Help tooltip for specific payment methods
          TooltipProvider(v-if="(method.name === 'paymentwall' || method.name === 'paypal') && $i18n.locale === 'zh'" :delayDuration="100")
            Tooltip
              TooltipTrigger(as-child)
                a.help-icon(
                  :href="method.name === 'paymentwall' ? '/knowledges/115' : '/knowledges/113'"
                  target="_blank"
                  @click.stop
                )
                  Icon(name="material-symbols:help-outline-rounded")
              TooltipContent(side="top" align="end")
                a.help-icon(
                  :href="method.name === 'paymentwall' ? '/knowledges/115' : '/knowledges/113'"
                  target="_blank"
                  @click.stop
                )
                  span(v-if="method.name === 'paymentwall'") 填银行卡号即可，查看教程
                  span(v-if="method.name === 'paypal'") 无需注册PayPal，查看教程

        .logos-container
          .logos-wrapper(v-if="method.name === 'stripe_card' || method.name === 'stripe_pandatl_card'")
            img(src="/img/visa-selfhst.svg" alt="Visa" class="h-8 w-8 inline-block")
            Icon(name="logos:mastercard" class="h-7 inline-block")
            Icon(name="logos:unionpay" class="h-6 inline-block")
            Icon(name="logos:amex" class="h-6 inline-block")
            Icon(name="simple-icons:applepay" class="h-8 w-8 inline-block text-black dark:text-white" aria-label="Apple Pay")
            Icon(name="logos:google-pay" class="h-6 inline-block" aria-label="Google Pay")

          .logos-wrapper(v-if="method.name === 'paypal'")
            Icon(name="logos:paypal" class="h-7 inline-block")

          .logos-wrapper(v-if="method.name === 'paymentwall'")
            Icon(name="logos:unionpay" class="h-6 inline-block")
            img.payment-logo.unionpay-text(src='https://alicloud-assets.oss-accelerate.aliyuncs.com/img/UnionPay_LOGO.png' alt="UnionPay")

          .logos-wrapper(v-if="method.name === 'paymentwall_cc'")
            Icon(name="logos:jcb" class="h-7 inline-block")
            Icon(name="logos:visa" class="h-4 inline-block")
            Icon(name="logos:mastercard" class="h-7 inline-block")
            Icon(name="logos:amex" class="h-6 inline-block")

          .logos-wrapper(v-if="method.name === 'stripe_ideal'")
            Icon(name="cib:ideal" class="h-6 inline-block")

  .more-options
    DropdownMenu
      DropdownMenuTrigger(as-child)
        button.more-btn
          Icon(name="material-symbols:more-horiz" class="more-icon")
          span {{ $t('more-payment-method') }}
      DropdownMenuContent(align="end" class="w-56")
        DropdownMenuItem(@click="showBillingEditor")
          Icon(name="material-symbols:edit-rounded" class="mr-2 h-4 w-4")
          span {{ $t('update_billing.edit') }}
        DropdownMenuSeparator
        DropdownMenuItem(@click="showMorePaymentOptions")
          Icon(name="material-symbols:payments-rounded" class="mr-2 h-4 w-4")
          span {{ $t('more-payment-methods') }}
</template>

<script lang="ts" setup>
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import UpdateBilling from '@/components/UpdateBilling.vue'

let userChangedPaymntMethod = false
const $t = useI18n().t
const user = useUser()
const session = useVisitorSession()
const service = useUserService()
const pricing = usePricing()
if (pricing.prefilled && pricing.selectedPaymentMethod?.name) {
  userChangedPaymntMethod = true
}
const props = defineProps<{
  mode: string,
  cate: string,
}>()
const allowedPaymentMethodsFromServer = computed(() => user.allowedPaymentMethodsFromServer)
const selectedPaymentMethod = computed(() => pricing.selectedPaymentMethod)
const hasService = computed(() => service.hasService)
const cnyMethods = computed(() => {
  return [
    // { name: 'alipay_pc', currency: 'CNY', hide: !session.isAdmin && !this.isAllowedPaymentMethod('alipay') },
    // { name: 'alipay_mobile', currency: 'CNY', hide: !session.isAdmin && !this.isAllowedPaymentMethod('alipay') },
  ]
})
const eurMethods = computed(() => {
  return [
    // { name: 'yaband_alipay', currency: 'EUR' },
    // { name: 'braintree', currency: 'EUR' },
    // { name: 'stripe_pandatl_card', currency: 'EUR' },
    { name: 'stripe_card', currency: 'EUR' },
    // { name: 'stripe_alipay', currency: 'EUR' },
    // { name: 'yaband_wechat', currency: 'EUR' },
    // { name: 'stripe_wechat', currency: 'EUR', adminOnly: true },
    // { name: 'paymentwall', currency: 'EUR' },
    { name: 'paymentwall', currency: 'EUR' },
    // 如果不是管理员，也没用买过服务，那么就不显示PayPal
    { name: 'paypal', currency: 'EUR', hide: !session.isAdmin && !isAllowedPaymentMethod('paypal') },
    { name: 'stripe_ideal', currency: 'EUR' },
    { name: 'paymentwall_pandapro', currency: 'EUR', allowedUserIds: [273216], adminOnly: false },
    // { name: 'paymentwall_cc', currency: 'EUR', adminOnly: false },
    // { name: 'adyen_unionpay', currency: 'EUR', adminOnly: true },
  ]
})
const paymentMethods = computed(() => {
  // if (this.mode === 'topUp') {
  //   return [...this.cnyMethods, ...this.eurMethods]
  // }
  // if (this.selectedCate === 'allplatform') {
  //   return [...this.cnyMethods, ...this.eurMethods]
  // }
  // return [...this.cnyMethods, ...this.eurMethods]
  return [...eurMethods.value, ...cnyMethods.value].filter((method) => {
    console.log(method.name, method.hide)
    if (method.hide) {
      return false
    }
    if (method.adminOnly) {
      return session.isAdmin
    }
    if (method.name === 'stripe_ideal') {
      if (user.billing?.country === 'Netherlands') {
        return true
      }
      return false
    }
    if (method.currency === 'CNY') {
      if (hasService.value) {
        return true
      }
      return false
    }
    if (method.allowedUserIds) {
      return method.allowedUserIds.includes(user.id!)
    }
    return true
  })
})

watch(
  paymentMethods,
  (methods) => {
    if (!methods.length) {
      return
    }
    if (!selectedPaymentMethod.value?.name) {
      return
    }
    const matched = methods.find((method) => method.name === selectedPaymentMethod.value?.name)
    if (!matched) {
      selectPaymentMethod(methods[0], false)
      return
    }
    if (selectedPaymentMethod.value?.currency !== matched.currency) {
      selectPaymentMethod(matched, false)
    }
  },
  { immediate: true },
)

watch(() => props.mode, (val) => {
  if (val === 'topUp') {
    if (!userChangedPaymntMethod) {
      selectDefaultPaymentMethod()
    }
  }
})
watch(() => props.cate, (val) => {
  // selectDefaultPaymentMethod()
  if (!userChangedPaymntMethod) {
    selectDefaultPaymentMethod()
  }
})

onMounted(() => {
  console.log('payment options module mounted')
  if (!selectedPaymentMethod.value?.name) selectDefaultPaymentMethod()
  if (session.loggedIn) {
    getAllowedPaymentMethodsFromServer()
  }
})

async function scrollToBillingFormIfVisible() {
  await nextTick()
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }
  window.requestAnimationFrame(() => {
    document.getElementById('billing-address-form')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  })
}

function selectPaymentMethod(method, isUserSelect = true) {
  console.log('select new payment method:', method)
  if (isUserSelect) {
    userChangedPaymntMethod = true
  }
  pricing.selectedPaymentMethod = method
  if (isUserSelect) {
    void scrollToBillingFormIfVisible()
  }
}
function showBillingEditor() {
  // Use the extended useDialog to show UpdateBilling component
  useDialog().custom({
    component: UpdateBilling,
    title: $t('update_billing.edit'),
    dialogContentClass: 'max-w-[800px]',
    componentWrapperClass: 'p-0',
    hideButtons: true
  })
}

function showMorePaymentOptions() {
  const body = [
    $t('bank-transfer.name'),
    $t('bank-transfer.content'),
    $t('bank-transfer.after'),
    $t('crypto-transfer.name')
  ].join('\n\n')
  useDialog().alert({
    title: $t('more-payment-method'),
    body,
    confirmButtonText: $t('ok')
  })
}
async function getAllowedPaymentMethodsFromServer() {
  try {
    await user.getAllowedPaymentMethods()
  } catch (e) {
    console.log(e)
  }
}
function isAllowedPaymentMethod(method) {
  console.log(
    'allowed payment methods:',
    user?.extra?.allowed_payment_methods,
    user?.extra?.allowed_payment_methods?.includes(method)
  )
  return (
    user?.extra?.allowed_payment_methods?.includes(method) ||
    allowedPaymentMethodsFromServer.value.includes(method)
  )
}

function selectDefaultPaymentMethod() {
  if (paymentMethods.value.length) selectPaymentMethod(paymentMethods.value[0], false)
}

defineExpose({
  selectDefaultPaymentMethod,
})
</script>

<style lang="postcss" scoped>

.payment-method-modern {
  background: transparent !important;
  padding: 0;
  border: none !important;
  box-shadow: none !important;

  .payment-grid {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  .payment-option {
    position: relative;
    cursor: pointer;

    /* Remove any card styling from this container */
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;

    /* Match el-card styling through inner element */
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: color-mix(in oklch, var(--pricing-solid-surface) 92%, transparent);
      /* backdrop-filter: blur(14px) saturate(120%);
      -webkit-backdrop-filter: blur(14px) saturate(120%); */
      border: 1px solid var(--pricing-border);
      box-shadow: none;
      border-radius: 12px;
      transition:
        border-color 150ms cubic-bezier(0.22, 1, 0.36, 1),
        box-shadow 150ms cubic-bezier(0.22, 1, 0.36, 1);
      z-index: 0;

      .light & {
        background: var(--pricing-white);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
      }
    }

    &:hover {
      &::before {
        border-color: color-mix(in srgb, var(--pricing-text) 16%, transparent);
      }

      .radio-outer {
        border-color: color-mix(in srgb, var(--pricing-accent) 50%, transparent);
      }
    }

    &.is-selected {
      position: relative;

      &::before {
        /* Match selected styling from pricing page */
        border-color: var(--pricing-accent);
        box-shadow: inset 0 0 0 1px var(--pricing-accent) !important;

        .light & {
          border-color: var(--pricing-accent);
          box-shadow: inset 0 0 0 1px var(--pricing-accent) !important;
        }
      }

      .radio-outer {
        border-color: var(--pricing-accent);
      }

      .radio-inner {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
      }

      .method-name {
        color: var(--primary-color);
      }
    }
  }

  .option-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    padding: 0.6rem 0.8rem;
  }

  .option-header {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    position: relative;
  }

  .radio-indicator {
    position: relative;
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    .radio-outer {
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border: 2px solid color-mix(in srgb, var(--pricing-white) 20%, transparent);
      border-radius: 50%;
      transition: border-color 150ms cubic-bezier(0.22, 1, 0.36, 1);

      .light & {
        border-color: color-mix(in srgb, black 20%, transparent);
      }
    }

    .radio-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 8px;
      height: 8px;
      background: var(--pricing-accent);
      border-radius: 50%;
      transform: translate(-50%, -50%) scale(0);
      opacity: 0;
      transition:
        transform 150ms cubic-bezier(0.22, 1, 0.36, 1),
        opacity 150ms cubic-bezier(0.22, 1, 0.36, 1);
      transform-origin: center center;
    }
  }

  .method-name {
    font-size: 1rem;
    font-weight: 500;
    color: var(--secondary-color);
    transition: color 150ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  .logos-container {
    padding-left: calc(20px + 0.45rem);
  }

  .logos-wrapper {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    flex-wrap: wrap;
  }

  .payment-logo {
    height: 24px;
    width: auto;
    object-fit: contain;
    opacity: 0.85;
    transition: color 150ms cubic-bezier(0.22, 1, 0.36, 1), background-color 150ms cubic-bezier(0.22, 1, 0.36, 1), border-color 150ms cubic-bezier(0.22, 1, 0.36, 1), opacity 150ms cubic-bezier(0.22, 1, 0.36, 1);

    .payment-option:not(.is-selected) & {
      filter: grayscale(20%);
    }

    .payment-option:hover &,
    .payment-option.is-selected & {
      opacity: 1;
      filter: none;
    }

    &.paypal-logo {
      height: 28px;
      color: #003087;

      .dark & {
        color: #0070ba;
      }
    }

    &.unionpay-text {
      height: 30px;
      filter: none !important;
    }

    &.jcb-logo {
      height: 28px;
    }

    &.ideal-logo {
      height: 26px;
    }
  }

  /* Icon component styles in logos container */
  .logos-wrapper {
    :deep(.iconify) {
      opacity: 0.85;
      transition: color 150ms cubic-bezier(0.22, 1, 0.36, 1), background-color 150ms cubic-bezier(0.22, 1, 0.36, 1), border-color 150ms cubic-bezier(0.22, 1, 0.36, 1), opacity 150ms cubic-bezier(0.22, 1, 0.36, 1);
      vertical-align: middle;

      .payment-option:not(.is-selected) & {
        filter: grayscale(20%);
      }

      .payment-option:hover &,
      .payment-option.is-selected & {
        opacity: 1;
        filter: none;
      }
    }
  }

  @media (max-height: 820px) {
    .payment-grid {
      gap: 0.35rem;
    }

    .payment-option::before {
      border-radius: 16px;
    }

    .option-content {
      gap: 0.25rem;
      padding: 0.45rem 0.7rem;
    }

    .method-name {
      font-size: 1rem;
    }
  }

  @media (max-height: 700px) {
    .payment-grid {
      gap: 0.25rem;
    }

    .option-content {
      gap: 0.2rem;
      padding: 0.35rem 0.65rem;
    }
  }

  .help-icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: var(--secondary-color);
    opacity: 0.6;
    transition: color 150ms cubic-bezier(0.22, 1, 0.36, 1), background-color 150ms cubic-bezier(0.22, 1, 0.36, 1), border-color 150ms cubic-bezier(0.22, 1, 0.36, 1), opacity 150ms cubic-bezier(0.22, 1, 0.36, 1);
    text-decoration: none !important;

    &:hover {
      opacity: 1;
      color: var(--pricing-accent);
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .more-options {
    margin-top: 0.2rem;
    display: flex;
    justify-content: flex-end;
    padding-right: 0;
  }

  .more-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0;
    background: transparent;
    border: none;
    color: var(--secondary-color);
    font-size: 0.75rem;
    cursor: pointer;
    transition: color 150ms cubic-bezier(0.22, 1, 0.36, 1), background-color 150ms cubic-bezier(0.22, 1, 0.36, 1), border-color 150ms cubic-bezier(0.22, 1, 0.36, 1), opacity 150ms cubic-bezier(0.22, 1, 0.36, 1);
    opacity: 0.5;
    position: relative;

    .light & {
      opacity: 0.45;
    }

    &:hover {
      opacity: 0.8;

      span {
        text-decoration: underline;
      }
    }

    .more-icon {
      font-size: 0.9rem;
      opacity: 0.6;
      transition: color 150ms cubic-bezier(0.22, 1, 0.36, 1), background-color 150ms cubic-bezier(0.22, 1, 0.36, 1), border-color 150ms cubic-bezier(0.22, 1, 0.36, 1), opacity 150ms cubic-bezier(0.22, 1, 0.36, 1);
    }
  }
}

/* Remove ::before from dialog to prevent scrollbar issues */
:global(.dialog-content::before) {
  content: none !important;
}
</style>
